export default __webpack_public_path__ + "static/media/recruit-acc1.0ca1e4c6.svg";